<template>
  <!-- GLOBAL OPTIONS -->

  <div class="options" v-if="data != null">
    <h1 class="overline">Opcje globalne</h1>
    <v-divider />
    <v-container class="mt-2 ml-10">
      <v-form>
        <div
          v-for="property in orderedProperties"
          :key="property.id"
          class="mb-4"
          style="max-width: 400px; width: 100%; margin-left: 0"
        >
          <template v-if="property.propertyName == 'MARGIN_PERCENTAGE'">
            <v-text-field
              dense
              outlined
              type="number"
              hint="Procent marży dla ostrzeżeń o produktach"
              suffix="%"
              min="0"
              max="100"
              v-model="property.value"
              :label="'Procent marży (MARGIN_PERCENTAGE)'"
              required
              persistent-hint
              style="max-width: 400px"
            ></v-text-field>
          </template>
          <template v-else-if="property.propertyName == 'INGRAM_ORDER_SYNC'">
            <v-switch
              v-model="property.value"
              :false-value="0"
              :true-value="1"
              :label="'Synchronizacja zamówień Ingram (INGRAM_ORDER_SYNC)'"
              persistent-hint
              hint="Włącz/wyłącz synchronizację zamówień Ingram"
              style="max-width: 400px"
            ></v-switch>
          </template>
          <template
            v-else-if="property.propertyName == 'SHOPER_DELIVERY_OVERRIDE'"
          >
            <v-switch
              v-model="property.value"
              :false-value="0"
              :true-value="1"
              :label="'Nadpisz czas dostawy Shoper (SHOPER_DELIVERY_OVERRIDE)'"
              persistent-hint
              hint="Włącz/wyłącz nadpisywanie czasu dostawy Shoper"
              style="max-width: 400px"
            ></v-switch>
          </template>
          <template
            v-else-if="
              property.propertyName == 'SHOPER_DELIVERY_OVERRIDE_VALUE' &&
              getPropertyValue('SHOPER_DELIVERY_OVERRIDE') === 1
            "
          >
            <v-text-field
              dense
              outlined
              type="number"
              hint="ID dostawy Shoper do nadpisania"
              suffix="ID"
              min="1"
              max="11"
              v-model="property.value"
              :label="'ID dostawy Shoper (SHOPER_DELIVERY_OVERRIDE_VALUE)'"
              required
              persistent-hint
              style="max-width: 400px"
            ></v-text-field>
          </template>
        </div>
        <v-btn
          depressed
          outlined
          x-large
          height="39.5px"
          color="rgba(0, 0, 0, 0.6)"
          class="mt-2"
          @click="submitAllProperties"
          >Zapisz wszystkie</v-btn
        >
      </v-form>
    </v-container>

    <!-- TRELLO LABELS -->

    <h1 class="overline">Etykiety Trello</h1>
    <v-divider />
    <v-container class="mx-4 mt-2" fill-height v-if="trelloLabels != null">
      <v-row>
        <v-col
          cols="12"
          sm="2"
          md="2"
          lg="2"
          v-for="label in trelloLabels"
          :key="label.id"
        >
          <v-container>
            <div class="d-flex" v-if="availableTrelloLabels != null">
              <v-autocomplete
                :value="label.name"
                :label="label.staticName"
                dense
                class="ml-3"
                depressed
                outlined
                :items="availableTrelloLabels"
                item-text="name"
                return-object
                @input="updateTrelloLabelsArray(label.id, $event)"
              >
              </v-autocomplete>
            </div>
          </v-container>
        </v-col>
      </v-row>
      <v-container>
        <div class="d-flex">
          <v-btn
            depressed
            outlined
            x-large
            height="39.5px"
            color="rgba(0, 0, 0, 0.6)"
            @click="updateTrelloLabels()"
            >Aktualizuj etykiety</v-btn
          >
        </div>
      </v-container>
    </v-container>

    <!-- ACOUNT DETAILS -->

    <h1 class="overline">Szczegóły konta</h1>
    <v-divider />

    <v-container class="mx-4 mt-2" v-if="userDetails != null">
      <v-row>
        <v-col>
          <v-text-field
            dense
            outlined
            disabled
            label="Nazwa użytkownika"
            v-model="userDetails.username"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            dense
            outlined
            disabled
            label="Imię"
            v-model="userDetails.name"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            dense
            outlined
            disabled
            label="Nazwisko"
            v-model="userDetails.surname"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            dense
            outlined
            disabled
            label="Stanowisko"
            v-model="userDetails.businessTitle"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            dense
            outlined
            disabled
            label="Adres email"
            v-model="userDetails.email"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            dense
            outlined
            disabled
            label="Numer telefonu"
            v-model="userDetails.phone"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-checkbox
            dense
            disabled
            label="Uwierzytelnianie dwuskładnikowe (2FA)"
            v-model="userDetails.using2FA"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-container>

    <!-- CHANGE PASSWORD -->

    <h1 class="overline">Opcje konta</h1>
    <v-divider />
    <v-form>
      <v-container class="mx-4 mt-2">
        <div class="d-flex">
          <v-row>
            <v-col>
              <v-text-field
                dense
                outlined
                v-model="oldPassword"
                :type="show1 ? 'text' : 'password'"
                hint="Wprowadź swoje stare hasło"
                autocomplete="off"
                label="Stare hasło"
                required
                @click:append="show1 = !show1"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                dense
                outlined
                v-model="newPassword"
                autocomplete="off"
                hint="Wprowadź nowe hasło"
                :rules="[rules.min]"
                label="Nowe hasło"
                required
                :type="show2 ? 'text' : 'password'"
                @click:append="show2 = !show2"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-btn
                depressed
                outlined
                x-large
                height="39.5px"
                color="rgba(0, 0, 0, 0.6)"
                @click="changePassword()"
                >Zmień hasło</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-form>

    <v-container class="mx-4 mt-2 mb-6" v-if="userDetails.using2FA == false">
      <div class="d-flex">
        <v-row>
          <v-col>
            <v-btn
              depressed
              outlined
              x-large
              height="39.5px"
              color="rgba(0, 0, 0, 0.6)"
              @click="enable2fa()"
              >Włącz uwierzytelnianie dwuskładnikowe (2FA)</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-dialog v-model="showfa2" width="700px" persistent>
      <v-card class="pa-4">
        <v-alert color="success" icon="$success" title="Alert title"
          >Pomyślnie włączono uwierzytelnianie dwuskładnikowe, zeskanuj poniższy
          kod QR w aplikacji Authenticator:</v-alert
        >
        <v-img v-if="fa2url != null" :width="300" :src="fa2url" />
        <v-btn @click="showfa2 = false">Kliknij aby potwierdzić</v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "Options",
  methods: {
    updateTrelloLabelsArray(objectId, trelloLabelObject) {
      this.trelloLabels.forEach((element) => {
        if (element.id == objectId) {
          element.name = trelloLabelObject.name;
          element.trelloId = trelloLabelObject.id;
          console.log(this.trelloLabels);
        }
      });
    },
    updateTrelloLabels() {
      this.$store
        .dispatch("updateTrelloLabels", this.trelloLabels)
        .then((response) => {
          if (response.data.sucess) {
            this.$store.dispatch("snackbar/setSnackbar", {
              color: "success",
              text: "Updated trello labels",
            });
          } else {
            this.$store.dispatch("snackbar/setSnackbar", {
              color: "success",
              text: "Refresh page",
            });
          }
        });
    },
    getTrelloLabels() {
      this.$store
        .dispatch("getTrelloLabels")
        .then((response) => {
          this.trelloLabels = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "error",
            text: "Something went wrong with getTrelloLabels()",
          });
        });
    },
    getAvailableLabels() {
      this.$store
        .dispatch("getAvailableLabels")
        .then((response) => {
          this.availableTrelloLabels = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "error",
            text: "Something went wrong with getAvailableLabels()",
          });
        });
    },
    submitAllProperties() {
      // Iteracja po wszystkich opcjach i wysyłka każdej osobno
      const promises = this.data.map((property) =>
        this.$store.dispatch("changeProperty", {
          id: property.id,
          value: property.value,
        })
      );
      Promise.all(promises)
        .then(() => {
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "success",
            text: "Wszystkie opcje zapisane",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "error",
            text: "Błąd podczas zapisywania opcji",
          });
        });
    },
    changePassword() {
      this.$store
        .dispatch("changePassword", {
          newPassword: this.newPassword,
          oldPassword: this.oldPassword,
        })
        .then((response) => {
          if (response.data.sucess) {
            this.$store.dispatch("snackbar/setSnackbar", {
              color: "success",
              text: "Password changed",
            });
          } else {
            this.$store.dispatch("snackbar/setSnackbar", {
              color: "error",
              text: "Incorrect password",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "error",
            text: "Something went wrong with changePassword()",
          });
        });
    },
    enable2fa() {
      this.$store
        .dispatch("enable2fa")
        .then((response) => {
          this.showfa2 = true;
          this.fa2url = response.data;
          this.userDetails.using2FA = true;
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "success",
            text: "Włączono uwierzyelnianie dwuskładnikowe",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "error",
            text: "Something went wrong with changePassword()",
          });
        });
    },
    getAllProperties() {
      this.$store
        .dispatch("getAllProperties", {})
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "error",
            text: "Something went wrong with getAllProperties()",
          });
        });
    },
    getUserDetails() {
      this.$store
        .dispatch("getUserDetails", {})
        .then((response) => {
          this.userDetails = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "error",
            text: "Something went wrong with getUserDetails()",
          });
        });
    },
    getPropertyValue(name) {
      if (!this.data) return null;
      const prop = this.data.find((p) => p.propertyName === name);
      return prop ? prop.value : null;
    },
  },
  data() {
    return {
      trelloLabels: null,
      availableTrelloLabels: null,
      data: null,
      show1: false,
      show2: false,
      userDetails: null,
      newPassword: null,
      oldPassword: null,
      rules: { min: (v) => v.length >= 6 || "Minimum 6 characters" },
      ex3: { label: "thumb-color", val: 50, color: "grey" },
      fa2url: null,
      showfa2: false,
    };
  },
  mounted() {
    this.getAllProperties();
    this.getUserDetails();
    this.getTrelloLabels();
    this.getAvailableLabels();
  },
  computed: {
    orderedProperties() {
      const order = [
        "MARGIN_PERCENTAGE",
        "INGRAM_ORDER_SYNC",
        "SHOPER_DELIVERY_OVERRIDE",
        "SHOPER_DELIVERY_OVERRIDE_VALUE",
      ];
      if (!this.data) return [];
      return order
        .map((name) => this.data.find((p) => p.propertyName === name))
        .filter(Boolean);
    },
    readableValue() {
      return this.value + "%";
    },
  },
};
</script>
